import { render, staticRenderFns } from "./KickOutDetail.vue?vue&type=template&id=e5f35972&scoped=true&"
import script from "./KickOutDetail.vue?vue&type=script&lang=js&"
export * from "./KickOutDetail.vue?vue&type=script&lang=js&"
import style0 from "./KickOutDetail.vue?vue&type=style&index=0&id=e5f35972&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f35972",
  null
  
)

export default component.exports